export default __webpack_public_path__ + "static/media/onboarding-listing.ef9260a1.jpeg";